import { render, staticRenderFns } from "./AdminApiAuth.vue?vue&type=template&id=8221855a&scoped=true"
import script from "./AdminApiAuth.vue?vue&type=script&lang=js"
export * from "./AdminApiAuth.vue?vue&type=script&lang=js"
import style0 from "./AdminApiAuth.vue?vue&type=style&index=0&id=8221855a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8221855a",
  null
  
)

export default component.exports